import type { PartiallyGuardedPlayerPositionManagerProps } from './PartiallyGuardedPlayerPositionManager';
import { useFullyGuardedPlayerPositionManager } from './useFullyGuardedPlayerPositionManager';

export type FullyGuardedPlayerPositionManagerProps<TPlayerParentContainer> = Pick<
  PartiallyGuardedPlayerPositionManagerProps<TPlayerParentContainer>,
  | 'bottomStyleWhenStickyAtBottomRight'
  | 'leftStyleWhenStickyAtTop'
  | 'player'
  | 'playerParentContainer'
  | 'rightStyleWhenStickyAtBottomRight'
  | 'rightStyleWhenStickyAtTop'
  | 'topStyleWhenStickyAtTop'
  | 'widthStyleWhenStickyAtBottomRight'
> & {
  intersectionObserverTarget: NonNullable<
    PartiallyGuardedPlayerPositionManagerProps<TPlayerParentContainer>['intersectionObserverTarget']
  >;
  nonStickyPlayerPhantom: NonNullable<
    PartiallyGuardedPlayerPositionManagerProps<TPlayerParentContainer>['nonStickyPlayerPhantom']
  >;
};

export const FullyGuardedPlayerPositionManager = <TPlayerParentContainer extends HTMLElement>({
  bottomStyleWhenStickyAtBottomRight,
  intersectionObserverTarget,
  leftStyleWhenStickyAtTop,
  nonStickyPlayerPhantom,
  player,
  playerParentContainer,
  rightStyleWhenStickyAtBottomRight,
  widthStyleWhenStickyAtBottomRight,
  rightStyleWhenStickyAtTop,
  topStyleWhenStickyAtTop,
}: FullyGuardedPlayerPositionManagerProps<TPlayerParentContainer>): null => {
  useFullyGuardedPlayerPositionManager({
    bottomStyleWhenStickyAtBottomRight,
    intersectionObserverTarget,
    leftStyleWhenStickyAtTop,
    nonStickyPlayerPhantom,
    player,
    playerParentContainer,
    rightStyleWhenStickyAtBottomRight,
    rightStyleWhenStickyAtTop,
    topStyleWhenStickyAtTop,
    widthStyleWhenStickyAtBottomRight,
  });

  return null;
};
